// Multi-language support system for ACCTOO
// Supports major Indian languages with Unicode fonts

import { en_IN } from './en-IN';
import { hi_IN } from './hi-IN';

// Language configuration
export const SUPPORTED_LANGUAGES = {
  'en-IN': {
    name: 'English (India)',
    nativeName: 'English',
    flag: '🇮🇳',
    direction: 'ltr',
    fontFamily: 'Inter, system-ui, sans-serif'
  },
  'hi-IN': {
    name: 'Hindi',
    nativeName: 'हिन्दी',
    flag: '🇮🇳',
    direction: 'ltr',
    fontFamily: 'Noto Sans Devanagari, Inter, system-ui, sans-serif'
  }
};

// Translation data
export const translations = {
  'en-IN': en_IN,
  'hi-IN': hi_IN
};

console.log('Translations loaded:', translations);

// Default language
export const DEFAULT_LANGUAGE = 'en-IN';

// Get language info
export const getLanguageInfo = (languageCode) => {
  return SUPPORTED_LANGUAGES[languageCode] || SUPPORTED_LANGUAGES[DEFAULT_LANGUAGE];
};

// Get translation for a key
export const getTranslation = (key, languageCode = DEFAULT_LANGUAGE, fallback = true) => {
  const translation = translations[languageCode];
  if (translation && translation[key]) {
    return translation[key];
  }
  
  if (fallback && languageCode !== DEFAULT_LANGUAGE) {
    const fallbackTranslation = translations[DEFAULT_LANGUAGE];
    if (fallbackTranslation && fallbackTranslation[key]) {
      return fallbackTranslation[key];
    }
  }
  
  return key; // Return key if no translation found
};

// Get nested translation
export const getNestedTranslation = (path, languageCode = DEFAULT_LANGUAGE, fallback = true) => {
  const translation = translations[languageCode];
  const keys = path.split('.');
  let result = translation;
  
  for (const key of keys) {
    if (result && typeof result === 'object' && result[key]) {
      result = result[key];
    } else {
      if (fallback && languageCode !== DEFAULT_LANGUAGE) {
        const fallbackTranslation = translations[DEFAULT_LANGUAGE];
        let fallbackResult = fallbackTranslation;
        for (const fallbackKey of keys) {
          if (fallbackResult && typeof fallbackResult === 'object' && fallbackResult[fallbackKey]) {
            fallbackResult = fallbackResult[fallbackKey];
          } else {
            return path; // Return path if no translation found
          }
        }
        return fallbackResult;
      }
      return path; // Return path if no translation found
    }
  }
  
  return result;
};
